<template>
    <span>
        <a :href="href" v-on="listeners" v-bind="attrs"><slot></slot></a><v-icon x-small>mdi-open-in-new</v-icon>
    </span>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: ['href'],
        computed: {
            listeners() {
                const { ...listeners } = this.$listeners;
                return listeners;
            },
            attrs() {
                const { ...attrs } = this.$attrs;
                return attrs;
            }
        }
    };
</script>
